import React, { Component } from 'react'
import { Navbar, Nav } from 'react-bootstrap';
import { withRouter } from "react-router";

import styles from './EmplNavigation.module.css';
import navbarLogo from '../../assets/AppName.png';

class EmplNavigation extends Component {
    // constructor(){
    //     super();
    // }
    goToPage = (path) => {
        this.props.history.push("/dashboard/" + path);
    }
    render() {
        return (
            <React.Fragment>
                {/* <Navbar expand="lg">
                    <Navbar.Brand className="app-logo m-0">
                        <div></div><span className='camphire-main-logo-text'></span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <span id="username"></span>
                        <Nav className="mr-auto d-block d-sm-none">
                            <span id="username"></span>
                            <Nav.Link href="/dashboard/home" className="menu-item">Home</Nav.Link>
                            <Nav.Link onClick={() => this.goToPage('communication')} className="menu-item">Communication</Nav.Link>
                            <Nav.Link onClick={() => this.goToPage('assessment')} className="menu-item">Assessment</Nav.Link>
                            <Nav.Link onClick={() => this.goToPage('training')} className="menu-item">Training</Nav.Link>
                            <Nav.Link onClick={() => this.goToPage('manager')} className="menu-item">My Team</Nav.Link>
                            <Nav.Link onClick={() => this.goToPage('login')} className="menu-item">Logout</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar> */}
                <div className={`${styles.navbar_container} d-flex justify-content-between align-center`}>
                    <div className={styles.admin_app_logo}>
                        <img src={navbarLogo} alt='Elmaam Logo' />
                        {/* <span className='camphire-main-logo-text'></span> */}
                    </div>
                    <div className={styles.navbar_option}>
                        <span id="username"></span>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withRouter(EmplNavigation);
